import { defineAsyncComponent } from "vue";

export default Object.assign(
  {},
  defineAsyncComponent(() => import("./column-select-dropdown.vue")),
  { Filter: defineAsyncComponent(() => import("./filter.vue")) },
);
